// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M6 2H18V6H23V22H13V15H11V22H1V8H6V2ZM21 8H18V20H21V8ZM3 20H6V10H3V20Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-city-6-filled')
export default class City6FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'city-6-filled',
    }
  }
}
